import * as React from "react";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Title } from 'react-admin';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Typography from '@mui/material/Typography';
import { blue } from '@mui/material/colors';
import { usePermissions } from 'react-admin';

function Dashboard() {

    const { permissions } = usePermissions();
    console.log(permissions);

    return (
        <Card sx={{ mt: 10, textAlign: 'center', backgroundColor: '#f3f6f9' }}>
            <Title title="Dashboard" />
            {permissions === "admin" && (
                <CardContent>
                    {/* <ErrorOutlineIcon sx={{ fontSize: 60, color: 'red' }} /> */}
                    <Typography variant="h4" sx={{ margin: '20px 0', color: 'red' }}>
                        Dashboard - Admin
                    </Typography>
                    <Typography variant="subtitle1">
                        Pagina pricipale
                    </Typography>
                </CardContent>
            )}
            {permissions === "collaboratore" && (
                <CardContent>
                    {/* <ErrorOutlineIcon sx={{ fontSize: 60, color: 'red' }} /> */}
                    <Typography variant="h4" sx={{ margin: '20px 0', color: 'red' }}>
                        Dashboard - Collaboratore
                    </Typography>
                    <Typography variant="subtitle1">
                        Pagina pricipale
                    </Typography>
                </CardContent>
            )}
        </Card>
    );
}

export default Dashboard;
